import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/scheduleRepairActions'
import * as api from '../../api/job/scheduleRepair'
import { get } from 'lodash'

function* getScheduleRepairDates(action) {
  try {
    const payload = yield call(api.getScheduleRepairDates, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_REPAIR_SCHEDULES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_REPAIR_SCHEDULES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetScheduleRepairDates() {
  yield takeLatest(constants.GET_SCHEDULE_REPAIR_SCHEDULES.ACTION, getScheduleRepairDates)
}

function* sagaUpdateScheduleRepairDates(action) {
  try {
    const payload = {
      scheduleId: action.scheduleId,
      content: action.content
    }
    yield call(api.updateScheduleRepairDates, payload)
    yield put({ type: constants.SCHEDULE_REPAIR_UPDATE.SUCCESS, payload })
    yield call(getScheduleRepairDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_REPAIR_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleRepair() {
  yield takeLatest(constants.SCHEDULE_REPAIR_UPDATE.ACTION, sagaUpdateScheduleRepairDates)
}

function* sagaCreateScheduleRepairSchedule(action) {
  try {
    yield call(api.createScheduleRepairSchedule, action.jobId)
    yield put({ type: constants.SCHEDULE_REPAIR_ADD_SCHEDULE.SUCCESS })
    yield call(getScheduleRepairDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_REPAIR_ADD_SCHEDULE.FAILED,
      message: e.message || e
    })
  }
}

function* watchSagaCreateScheduleRepairSchedule() {
  yield takeLatest(constants.SCHEDULE_REPAIR_ADD_SCHEDULE.ACTION, sagaCreateScheduleRepairSchedule)
}

function* sagaDeleteScheduleRepairSchedule(action) {
  try {
    yield call(api.deleteScheduleRepairSchedule, {
      scheduleId: action.scheduleId,
      jobId: action.jobId
    })
    yield put({ type: constants.SCHEDULE_REPAIR_DELETE_SCHEDULE.SUCCESS })
    yield call(getScheduleRepairDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_REPAIR_DELETE_SCHEDULE.FAILED,
      message: e.message || e
    })
  }
}

function* watchSagaDeleteScheduleRepairSchedule() {
  yield takeLatest(
    constants.SCHEDULE_REPAIR_DELETE_SCHEDULE.ACTION,
    sagaDeleteScheduleRepairSchedule
  )
}

// notes
function* fetchScheduleRepairNote(action) {
  try {
    const payload = yield call(api.fetchScheduleRepairNote, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_REPAIR_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_REPAIR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchScheduleRepairNote() {
  yield takeLatest(constants.GET_SCHEDULE_REPAIR_NOTE.ACTION, fetchScheduleRepairNote)
}

function* createScheduleRepairNote(action) {
  try {
    const payload = {
      content: action.content,
      jobId: action.jobId
    }
    yield call(api.createScheduleRepairNote, payload)
    yield put({ type: constants.CREATE_SCHEDULE_REPAIR_NOTE.SUCCESS, payload })
    yield call(fetchScheduleRepairNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_SCHEDULE_REPAIR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateScheduleRepairNote() {
  yield takeLatest(constants.CREATE_SCHEDULE_REPAIR_NOTE.ACTION, createScheduleRepairNote)
}

function* editScheduleRepairNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editScheduleRepairNote, payload)
    yield put({ type: constants.EDIT_SCHEDULE_REPAIR_NOTE.SUCCESS, payload })
    yield call(fetchScheduleRepairNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_SCHEDULE_REPAIR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditScheduleRepairNote() {
  yield takeLatest(constants.EDIT_SCHEDULE_REPAIR_NOTE.ACTION, editScheduleRepairNote)
}

function* deleteScheduleRepairNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteScheduleRepairNote, payload)
    yield put({ type: constants.DELETE_SCHEDULE_REPAIR_NOTE.SUCCESS, payload })
    yield call(fetchScheduleRepairNote, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_REPAIR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleRepairNote() {
  yield takeLatest(constants.DELETE_SCHEDULE_REPAIR_NOTE.ACTION, deleteScheduleRepairNote)
}

function* uploadScheduleRepairAttachment(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId,
      userId: action.userId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_SCHEDULE_REPAIR_ATTACHMENT.SUCCESS, payload })
    yield call(reloadAttachments, {
      payload: {
        data: [{ job_id: action.jobId }]
      }
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_DOB_FOLDER_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* reloadAttachments(data) {
  const jobid = get(data, 'payload.data.0.job_id', null)
  const payload = yield call(api.getAttachments, [jobid])
  yield put({ type: constants.FETCH_SCHEDULE_REPAIR_ATTACHMENTS.SUCCESS, payload })
}

function* watchAttachments() {
  yield takeLatest(constants.GET_SCHEDULE_REPAIR_SCHEDULES.SUCCESS, reloadAttachments)
}

function* watchUploadAttachments() {
  yield takeLatest(
    constants.UPLOAD_SCHEDULE_REPAIR_ATTACHMENT.ACTION,
    uploadScheduleRepairAttachment
  )
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: action.userId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(reloadAttachments, {
      payload: {
        data: [{ job_id: action.jobId }]
      }
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_MINUTE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      jobId: action.jobId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.SUCCESS, payload })
    yield call(reloadAttachments, {
      payload: {
        data: [{ job_id: action.jobId }]
      }
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_SCHEDULE_REPAIR_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* watchDeleteAttachmentDescription() {
  yield takeLatest(constants.DELETE_SCHEDULE_REPAIR_ATTACHMENT.ACTION, deleteAttachment)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetScheduleRepairDates),
    fork(watchUpdateScheduleRepair),
    fork(watchSagaCreateScheduleRepairSchedule),
    fork(watchSagaDeleteScheduleRepairSchedule),

    //notes
    fork(watchFetchScheduleRepairNote),
    fork(watchCreateScheduleRepairNote),
    fork(watchEditScheduleRepairNote),
    fork(watchDeleteScheduleRepairNote),

    //attachments
    fork(watchAttachments),
    fork(watchUploadAttachments),
    fork(watchEditAttachmentDescription),
    fork(watchDeleteAttachmentDescription)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/scheduleRepairSaga.js